import { apiSlice } from './apiSlice'

/**
 * Sale Allocation — "Print - BBGN" report (Access `rpCtrlSalesBBGN`,
 * "Biên bản giao nhận" / goods handover record).
 *
 * Access port (VBA `btnPrintBBGN_Click` on `frmCtrlSalesMainSubFormSaleAlc`):
 *   1. Require the selected row's `delivery_order` (empty → warn
 *      "Delivery order must be not null!").
 *   2. Set query `CtrlSalesQryBBGNPrint` =
 *        SELECT (SELECT COUNT(*) FROM public_v_sale_allocation_print_scs AS sub
 *                WHERE sub.row_num <= main.row_num
 *                  AND sub.delivery_order = '<do>') AS row_number, main.*
 *        FROM public_v_sale_allocation_print_scs AS main
 *        WHERE main.delivery_order = '<do>' AND sale_contract = '<sc>';
 *   3. Open report `rpCtrlSalesBBGN` (a single-record handover document).
 *
 * NOTE — BACKEND NOT YET BUILT. The endpoint below is a placeholder mirroring the
 * proven `saleAllocationVgmPrintApi` / `saleDeliveryOrderApi` shape so the dialog
 * can compile and wire today. The URL marked `TODO BE` MUST be implemented before
 * this dialog is enabled in production. The lazy query returns the rendered HTML
 * (no silent fake data — until BE exists the request simply 404s).
 *
 * Cache tag reused: `SaleControl` (shared with the Sales Allocation datasheet).
 */

/** Request for the BBGN print preview — one delivery_order + its sale_contract. */
export interface BbgnPrintPreviewRequest {
  /** Selected row `delivery_order` (Access WHERE main.delivery_order = :do). */
  deliveryOrder: string
  /** Selected row `sale_contract` (Access WHERE sale_contract = :sc). */
  saleContract: string
}

export interface BbgnPrintPreviewResponse {
  /** Fully-built HTML (`access-report` + `.ctl` absolute layout) for the iframe. */
  html: string
  /** Suggested dialog title id part (the delivery_order). */
  title: string
  /** Optional info/warning relayed to the user (English). */
  message?: string
}

const saleAllocationBbgnPrintApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Build the BBGN (goods handover record) report HTML for one delivery order.
     * Access: `btnPrintBBGN_Click` sets `CtrlSalesQryBBGNPrint` + opens rpCtrlSalesBBGN.
     * TODO BE — GET /sale-allocations/bbgn-print/preview?delivery_order=<do>&sale_contract=<sc>
     *   → { html, title, message? }. BE renders the `rpCtrlSalesBBGN` absolute layout
     *   from `public_v_sale_allocation_print_scs` (filtered by delivery_order +
     *   sale_contract) plus the static TLC seller block from
     *   `public_tmp_add_information` (type='tlc_name_vn' / 'tlc_address_law_vn').
     */
    getBbgnPrintPreview: builder.query<BbgnPrintPreviewResponse, BbgnPrintPreviewRequest>({
      query: ({ deliveryOrder, saleContract }) => ({
        url: '/sale-allocations/bbgn-print/preview',
        params: { delivery_order: deliveryOrder, sale_contract: saleContract },
      }),
    }),
  }),
  overrideExisting: false,
})

export const { useLazyGetBbgnPrintPreviewQuery } = saleAllocationBbgnPrintApi

export default saleAllocationBbgnPrintApi
